import { Component } from "@angular/core";
import { DateTime } from "luxon";

@Component({
  selector: "gnl-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  currentYear = DateTime.now().toFormat("yyyy");
}
